import BaseModelAPI from '../BaseModelAPI';

export default class LookupDetail extends BaseModelAPI {
	static entity = 'lookupdetail';
	static entityName = 'lookupdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.lookupId = '';
			this.lookup = {};
			this.value = '';
			this.isEditable = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}